module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "u-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.joinSquad($event)
      }
    }
  }, [(_vm.joined) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "u-form-actions u-mt4"
  }, [_c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Done")])])]) : _c('div', [_c('div', {
    staticClass: "u-richtext u-mb2"
  }, [_c('p', [_vm._v("Let the leader of " + _vm._s(_vm.squad.name) + " that you're interested in joining the squad.")])]), _vm._v(" "), _c('div', {
    staticClass: "u-mb2 u-form-shortWrapper"
  }, [_c('label', {
    attrs: {
      "for": "join-squad-form-name"
    }
  }, [_vm._v("\n        Your Name\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "join-squad-form-name",
      "placeholder": "Provide your name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-mb2 u-form-shortWrapper"
  }, [_c('label', {
    attrs: {
      "for": "join-squad-form-email"
    }
  }, [_vm._v("\n        Email\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true }"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "join-squad-form-email",
      "placeholder": "Provide an email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-form-actions u-mt4"
  }, [_c('button', {
    staticClass: "Button Button--square",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Join " + _vm._s(_vm.squad.name))]), _vm._v(" "), _c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-richtext u-mb2"
  }, [_c('p', [_vm._v("Your name and contact information has been shared with the squad leader, who will contact you soon.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa159d88","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/join-squad.vue
// module id = 352
// module chunks = 0